export default {
  debug: false,

  logReduxActions: false,

  ga: {
    trackingId: 'UA-00000000-1',
    debug: false,
    logEnabled: false
  },

  searchAssociatesSite: {
    secure: true,
    host: 'apli.test.searchassociates.com',
    path: '/'
  },

  webApi: {
    secure: false,
      host: 'api.apli.local',
    path: '/'
  },

  // awayDelay + inactivityDelay + expiredDelay should be equal to 15 min (after this time user will be signed out)
  // awayDelay + inactivityDelay should be equal t0 10 min (at this time an inactivity warning will be shown)
  idleMonitor: {
    awayDelay: 5 * 60 * 1000, // 5 minutes
    inactiveDelay: 5 * 60 * 1000, // 5 minutes after it enters the away status
    expiredDelay: 5 * 60 * 1000 // 5 minutes after it enters the inactive status
  },

  refreshTokenBefore: 1 * 60 * 1000, // 1 minute

  syncAuthTokensDelayInMilliseconds: 2 * 1000, // 2 sec

  userActivation: {
    redirectDelayAfterActivation: 10 * 1000 //10 seconds
  }

  // set default values for config settings here
};



// WEBPACK FOOTER //
// ./src/config/default.js